<template>
	<FormSearchableInput2
		ref="searchable"
		:selected="selected"
		:list="searchList"
		:is-search-loading="isLoading"
		v-bind="$attrs"
		:search="handleSearch"
		@update:text="$emit('update:text', $event)"
		@update:selected="$emit('update:selected', $event)"
	/>
</template>
<script>
import TrackingEvents from "@/API/TrackingEvents.js"
import LoadingMixins from "@/mixins/loading.js"
import FormSearchableInput2 from "@/components/FormSearchableInput2.vue"

export default {
	name: "SelectProvider",
	mixins: [LoadingMixins],
	model: {
		prop: 'selected',
		event: 'update:selected'
	},
	props: {
		selected: [Object, Number, String],
		disabled: Boolean,
		onlyFulfillment: Boolean,
		onlyFreightForwarder: Boolean,
		onlyCargoAgent: Boolean,
		onlyFreight: Boolean,
		onlyFirstMile: Boolean,
		onlyLastMile: Boolean,
		onlyAirCompany: Boolean,
		withConfig: Boolean,
		partner: Object
	},
	components: {
		FormSearchableInput2
	},
	data() {
		return {
			searchList: []
		}
	},
	methods: {
		/**
		 * handle Search
		 * @param search
		 */
		async handleSearch(search) {

			const data = {
				search
			}

			const [err, res] = await TrackingEvents.getSelect(data)

			if (err) {
				// TODO...
				return []
			}

			return res.data.data
		},
		/**
		 * Export focus
		 */
		focus() {
			this.$refs.searchable.focus()
		},
		/**
		 * Export clear
		 */
		clear() {
			this.$refs.searchable.clear()
		}
	}
}
</script>